<mat-form-field class="filter">
  <mat-label>Filter</mat-label>
  <input [(ngModel)]="filter" matInput name="filter" (keyup)="applyFilter($event)">
</mat-form-field>
<div id="routing-servers-group-dialog-inner">
  <div id="selectable-routing-server-container">
    <div class="list-title">Routing Servers</div>
    <div class="inner-accordion-container">
      <table mat-table [dataSource]="selectableRoutingServers">
        <ng-container matColumnDef="status">
          <td mat-cell *matCellDef="let item">
            <div style="text-align: center" *ngIf="item.adminState === 'LOCKED' && item.status === 'AVAILABLE'"><i class="fa fa-lock available"></i></div>
            <div style="text-align: center" *ngIf="item.status !== 'AVAILABLE'"><i class="fa fa-times-circle unavailable"></i></div>
            <div style="text-align: center" *ngIf="item.status === 'AVAILABLE' && item.adminState !== 'LOCKED'"><i class="fa fa-check-circle available"></i></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <td mat-cell *matCellDef="let item" title="{{item.name}}">{{item.name}}</td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            class="path-row" (click)="onSelectSelectableRoutingServer(row)" [ngClass]="{'selected': selectInSelectableRoutingServerList(row)}">
        </tr>
      </table>
    </div>
  </div>

  <div id="add-remove-routing-server-in-inner-group-server-dialog">

    <button class="add-server-to-group" (click)="addToSelected()" color="primary" [disabled]="!hasItemsToAdd()" mat-icon-button>
      <mat-icon class="icons-inner">chevron_right</mat-icon>
    </button>
    <button class="remove-server-from-group" (click)="removeFromSelected()" color="primary" [disabled]="!hasItemsToRemove()" mat-icon-button>
      <mat-icon  class="icons-inner">chevron_left</mat-icon>
    </button>
  </div>

  <div id="selected-routing-server-container">
    <div class="list-title">Selected Routing Servers</div>
    <div class="inner-accordion-container">
      <table mat-table [dataSource]="selectedRoutingServers">
        <ng-container matColumnDef="status">
          <td mat-cell *matCellDef="let item">
            <div style="text-align: center" *ngIf="item.adminState === 'LOCKED' && item.status === 'AVAILABLE'"><i class="fa fa-lock available"></i></div>
            <div style="text-align: center" *ngIf="item.status !== 'AVAILABLE'"><i class="fa fa-times-circle unavailable"></i></div>
            <div style="text-align: center" *ngIf="item.status === 'AVAILABLE' && item.adminState !== 'LOCKED'"><i class="fa fa-check-circle available"></i></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <td mat-cell *matCellDef="let item" title="{{item.name}}">{{item.name}}</td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            class="path-row" (click)="onSelectSelectedRoutingServer(row)" [ngClass]="{'selected': selectInSelectedRoutingServerList(row)}">
        </tr>
      </table>
    </div>
  </div>

  <div id="move-up-down-routing-server-in-inner-group-server-dialog">

    <button class="move-server-up" (click)="moveUp()" [disabled]="!isUpAvailable()" color="primary" mat-icon-button matTooltip="Move up" [matTooltipPosition]="'right'">
      <mat-icon  class="icons-inner">arrow_upward</mat-icon>
    </button>
    <button class="move-server-down" (click)="moveDown()" [disabled]="!isDownAvailable()"  color="primary" mat-icon-button matTooltip="Move down" [matTooltipPosition]="'right'">
      <mat-icon  class="icons-inner">arrow_downward</mat-icon>
    </button>
  </div>
</div>

